import i18n_json from "@/assets/js/i18n.json";

function l(input) {
    if (localStorage.lang=="en-US") {
        let res = i18n_json[input];
        if (res != undefined) return res;
    }
    return input;
}

function GetResourceUrl(url) {
    if (process.env.VUE_APP_i18n) {
        return "https://duancaiwang-i18n.oss-cn-hangzhou.aliyuncs.com/frontend/images/" + url;
    } else {
        return "https://oss.chinaduancai.com/frontend/images/" + url;
    }
}

export { l, GetResourceUrl };